import {
  createDraftPost as publicCreateDraftPost,
  bulkCreateDraftPosts as publicBulkCreateDraftPosts,
  bulkUpdateDraftPosts as publicBulkUpdateDraftPosts,
  listDeletedDraftPosts as publicListDeletedDraftPosts,
  getDraftPost as publicGetDraftPost,
  updateDraftPost as publicUpdateDraftPost,
  deleteDraftPost as publicDeleteDraftPost,
  removeFromTrashBin as publicRemoveFromTrashBin,
  bulkDeleteDraftPosts as publicBulkDeleteDraftPosts,
  listDraftPosts as publicListDraftPosts,
  getDeletedDraftPost as publicGetDeletedDraftPost,
  restoreFromTrashBin as publicRestoreFromTrashBin,
  queryDraftPosts as publicQueryDraftPosts,
  publishDraftPost as publicPublishDraftPost,
} from './blog-v3-draft-draft-posts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onDraftCreated as publicOnDraftCreated } from './blog-v3-draft-draft-posts.public.js';
import { onDraftDeleted as publicOnDraftDeleted } from './blog-v3-draft-draft-posts.public.js';
import { onDraftUpdated as publicOnDraftUpdated } from './blog-v3-draft-draft-posts.public.js';

export const createDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicCreateDraftPost> & typeof publicCreateDraftPost
> = /*#__PURE__*/ createRESTModule(publicCreateDraftPost);
export const bulkCreateDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateDraftPosts> &
    typeof publicBulkCreateDraftPosts
> = /*#__PURE__*/ createRESTModule(publicBulkCreateDraftPosts);
export const bulkUpdateDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDraftPosts> &
    typeof publicBulkUpdateDraftPosts
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateDraftPosts);
export const listDeletedDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicListDeletedDraftPosts> &
    typeof publicListDeletedDraftPosts
> = /*#__PURE__*/ createRESTModule(publicListDeletedDraftPosts);
export const getDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicGetDraftPost> & typeof publicGetDraftPost
> = /*#__PURE__*/ createRESTModule(publicGetDraftPost);
export const updateDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDraftPost> & typeof publicUpdateDraftPost
> = /*#__PURE__*/ createRESTModule(publicUpdateDraftPost);
export const deleteDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDraftPost> & typeof publicDeleteDraftPost
> = /*#__PURE__*/ createRESTModule(publicDeleteDraftPost);
export const removeFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRemoveFromTrashBin> &
    typeof publicRemoveFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRemoveFromTrashBin);
export const bulkDeleteDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteDraftPosts> &
    typeof publicBulkDeleteDraftPosts
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteDraftPosts);
export const listDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicListDraftPosts> & typeof publicListDraftPosts
> = /*#__PURE__*/ createRESTModule(publicListDraftPosts);
export const getDeletedDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicGetDeletedDraftPost> &
    typeof publicGetDeletedDraftPost
> = /*#__PURE__*/ createRESTModule(publicGetDeletedDraftPost);
export const restoreFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRestoreFromTrashBin> &
    typeof publicRestoreFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRestoreFromTrashBin);
export const queryDraftPosts: MaybeContext<
  BuildRESTFunction<typeof publicQueryDraftPosts> & typeof publicQueryDraftPosts
> = /*#__PURE__*/ createRESTModule(publicQueryDraftPosts);
export const publishDraftPost: MaybeContext<
  BuildRESTFunction<typeof publicPublishDraftPost> &
    typeof publicPublishDraftPost
> = /*#__PURE__*/ createRESTModule(publicPublishDraftPost);
/**
 * Triggered when a draft post is created.
 */
export const onDraftCreated: BuildEventDefinition<typeof publicOnDraftCreated> =
  createEventModule(publicOnDraftCreated);
/**
 * Triggered when a draft post is deleted.
 */
export const onDraftDeleted: BuildEventDefinition<typeof publicOnDraftDeleted> =
  createEventModule(publicOnDraftDeleted);
/**
 * Triggered when a draft post is updated.
 */
export const onDraftUpdated: BuildEventDefinition<typeof publicOnDraftUpdated> =
  createEventModule(publicOnDraftUpdated);

export {
  Origin,
  NodeType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  BackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  Status,
  ModerationStatusStatus,
  TotalDraftPostsGroupingField,
  WebhookIdentityType,
  Type,
  Field,
  Action,
  GetDraftPostsSort,
  SortOrder,
} from './blog-v3-draft-draft-posts.universal.js';
export {
  DraftPost,
  CoverMedia,
  CoverMediaMediaOneOf,
  FocalPoint,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Border,
  Colors,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  V1Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  Gradient,
  Background,
  BackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  ModerationDetails,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  Media,
  MediaMediaOneOf,
  WixMedia,
  VideoResolution,
  EmbedMedia,
  EmbedThumbnail,
  EmbedVideo,
  DraftPostTranslation,
  DraftCategoriesUpdated,
  DraftTagsUpdated,
  GetDraftPostTotalsRequest,
  GetDraftPostTotalsResponse,
  TotalDraftPosts,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  InitialDraftPostsCopied,
  CreateDraftPostRequest,
  CreateDraftPostResponse,
  BulkCreateDraftPostsRequest,
  BulkCreateDraftPostsResponse,
  BulkDraftPostResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateDraftPostsRequest,
  MaskedDraftPosts,
  BulkUpdateDraftPostsResponse,
  DraftPostOwnerChanged,
  ListDeletedDraftPostsRequest,
  BlogPaging,
  ListDeletedDraftPostsResponse,
  MetaData,
  PagingMetadataV2,
  Cursors,
  GetDraftPostRequest,
  GetDraftPostResponse,
  UpdateDraftPostContentRequest,
  UpdateDraftPostContentResponse,
  UpdateDraftPostRequest,
  UpdateDraftPostResponse,
  DeleteDraftPostRequest,
  DeleteDraftPostResponse,
  RemoveFromTrashBinRequest,
  RemoveFromTrashBinResponse,
  BulkDeleteDraftPostsRequest,
  BulkDeleteDraftPostsResponse,
  ListDraftPostsRequest,
  ListDraftPostsResponse,
  GetDeletedDraftPostRequest,
  GetDeletedDraftPostResponse,
  RestoreFromTrashBinRequest,
  RestoreFromTrashBinResponse,
  QueryDraftPostsRequest,
  Sorting,
  PlatformQuery,
  PlatformQueryPagingMethodOneOf,
  Paging,
  CursorPaging,
  QueryDraftPostsResponse,
  PublishDraftPostRequest,
  PublishDraftPostResponse,
  UnpublishPostRequest,
  UnpublishPostResponse,
  TranslateCategoryRequest,
  TranslateCategoryResponse,
  Category,
  CategoryTranslation,
  TranslateDraftRequest,
  TranslateDraftResponse,
  IsDraftPostAutoTranslatableRequest,
  IsDraftPostAutoTranslatableResponse,
  UpdateDraftPostLanguageRequest,
  UpdateDraftPostLanguageResponse,
  BulkUpdateDraftPostLanguageRequest,
  BulkUpdateDraftPostLanguageResponse,
  GetPostAmountsByLanguageRequest,
  GetPostAmountsByLanguageResponse,
  PostAmountByLanguage,
  BulkRevertToUnpublishedRequest,
  BulkRevertToUnpublishedResponse,
  BulkRejectDraftPostRequest,
  BulkRejectDraftPostResponse,
  RevertToUnpublishedRequest,
  RevertToUnpublishedResponse,
  RejectDraftPostRequest,
  RejectDraftPostResponse,
  ApproveDraftPostRequest,
  ApproveDraftPostResponse,
  MarkPostAsInModerationRequest,
  MarkPostAsInModerationResponse,
  BaseEventMetadata,
  EventMetadata,
  DraftCreatedEnvelope,
  DraftDeletedEnvelope,
  DraftUpdatedEnvelope,
  CreateDraftPostOptions,
  BulkCreateDraftPostsOptions,
  BulkUpdateDraftPostsOptions,
  ListDeletedDraftPostsOptions,
  GetDraftPostOptions,
  UpdateDraftPost,
  UpdateDraftPostOptions,
  DeleteDraftPostOptions,
  BulkDeleteDraftPostsOptions,
  ListDraftPostsOptions,
  QueryDraftPostsOptions,
  DraftPostsQueryResult,
  DraftPostsQueryBuilder,
} from './blog-v3-draft-draft-posts.universal.js';
